import type { SxProps, Theme } from "@mui/material/styles";

/** Consistent dialog footer: padding, alignment, top border so actions don’t clip the paper. */
export const dialogActionsSx: SxProps<Theme> = {
  px: 3,
  py: 2.5,
  gap: 1.5,
  flexWrap: "wrap",
  alignItems: "center",
  justifyContent: "flex-end",
  borderTop: 1,
  borderColor: "divider",
  bgcolor: "background.paper",
};

/**
 * Outlined TextField labels extend above the input; `DialogContent` with `overflow: auto` clips them.
 * Use `PaperProps` on `Dialog` (MUI 5) + `dialogContentOutlinedFormSx` on `DialogContent` for outlined fields.
 */
export const dialogPaperPropsLabelSafe = {
  sx: { overflow: "visible" as const },
};

/** Stack layout + room for floating labels; pair with `dialogPaperPropsLabelSafe` on scroll="paper" dialogs. */
export const dialogContentOutlinedFormSx: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  gap: 2,
  pt: 3,
  overflow: "visible",
};
